import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    justificado: false,
    // faltaHora: false,
    color: '#ff0000', /* Rojo */
    restringido: false,
    inactivo: false,
    rowVersion: null,

    tipoNovedadDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, tipoFaltaId) {
        state.id = tipoFaltaId;
        state.nombre = '';
        state.justificado = false;
        // state.faltaHora = false;
        state.color = '#ff0000';
        state.restringido = false;
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_TIPO_NOVEDAD' (state, tipoFalta) {
        state.nombre= tipoFalta.nombre;
        state.justificado = tipoFalta.justificado;
        // state.faltaHora = tipoFalta.faltaHora;
        state.color = tipoFalta.color;
        state.restringido = tipoFalta.restringido;
        state.inactivo = tipoFalta.inactivo;
        state.rowVersion = tipoFalta.rowVersion;
    },

    'INICIALIZAR_DATOS' (state) {
        state.tipoNovedadDatos = [];
    },
    'SET_DATOS' (state, tipoNovedadDatos) {
        state.tipoNovedadDatos = tipoNovedadDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, tipoNovedadId ) {
        return new Promise((resolve, reject) => { 
            commit('INICIALIZAR', tipoNovedadId);

            if (tipoNovedadId != 0)
            {
                apiAxios.get('tiposnovedades/' + tipoNovedadId + '/abm' ) 
                .then(res => {
                    commit('SET_TIPO_NOVEDAD', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let tipoNovedad= {
                nombre: state.nombre.toUpperCase(),
                color: state.color.trim(),
                justificado: state.justificado,
                // faltaHora: state.faltaHora,
                restringido: state.restringido,
                inactivo: state.inactivo
            }

            let url = 'tiposnovedades';
            if (state.id != 0) {
                url += '/' + state.id;
                tipoNovedad.rowVersion= state.rowVersion;
            }

            apiAxios.post(url, tipoNovedad)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getDatos ( { commit }, tipoNovedadId ) {
        return new Promise((resolve, reject) => { 
            commit('INICIALIZAR_DATOS');

            apiAxios.get('tiposnovedades/' + tipoNovedadId) 
            .then(res => {
                var datos = [
                    { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                    { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                    { 'nombre': 'justificado', 'campo': 'Justificado', 'valor': res.data.justificado? 'Si' : 'No', 'formato': '' },
                    // { 'nombre': 'faltahora', 'campo': 'Falta x Hora', 'valor': res.data.faltaHora? 'Si' : 'No', 'formato': '' },
                    { 'nombre': 'restringido', 'campo': 'Restringido', 'valor': res.data.restringido? 'Si' : 'No', 'formato': '' },
                    { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': (res.data.inactivo)? 'Si' : 'No', 'formato': '' },
                ];
                commit('SET_DATOS', datos);
                resolve()
            })
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}